import React from "react";

import Marked from "components/Tvendo/Mobile/Marked";

export default function () {
  return <Marked />;
}
